// src/lib/messages.ts
//
// ★ HOW A FAILED REQUEST IS SAID TO AN OFFICER (UAT re-run F-30).
//
// An officer is told what happened and what to do next, in words they would use. They are never told about "the
// gateway", never shown a raw "internal error", and never offered Retry on a refusal that no retry can change.

/** The one sentence for "the request never got an answer". */
export const NETWORK_FAILURE =
  'PRS could not be reached. Check your network connection and try again. If it keeps failing, contact PRS support.'

/** A server fault with no useful sentence of its own. */
export const SERVER_FAULT =
  'PRS could not complete this request because of a fault on our side. Try again in a moment. If it keeps failing, contact PRS support.'

const BARE_SERVER_TEXT = /^(?:internal(?: server)? error|server error|bad gateway|service unavailable|gateway timeout|error|request failed with http 5\d\d)\.?$/i

/**
 * The words for an HTTP error. A server's own sentence is kept (it is specific, and the screens render it verbatim),
 * except where it is only a bare technical token, which is replaced by a sentence that says what to do.
 */
export function plainErrorMessage(status: number, message: string): string {
  const text = message.trim()
  if (status >= 500 && (text.length === 0 || BARE_SERVER_TEXT.test(text))) return SERVER_FAULT
  if (/^request failed with http \d{3}$/i.test(text)) {
    return `PRS could not complete this request (code ${status}). Check what you entered and try again. If it keeps failing, contact PRS support.`
  }
  return message
}

/** True when a retry could change the answer: a fault or a dropped connection, not a refusal or a missing record. */
export function isRetryable(status: number | null): boolean {
  return status === null || status >= 500 || status === 408 || status === 429
}
